import { render } from "./AppUserListItem.vue?vue&type=template&id=22ef3d16"
import script from "./AppUserListItem.vue?vue&type=script&lang=js"
export * from "./AppUserListItem.vue?vue&type=script&lang=js"

import exportComponent from "/chi/client/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__